import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CourseAssignmentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('CourseAssignment');
    }
    
	loadAll(searchObj: ePM.Logic.PersonSearchVM) : Observable<ePM.Logic.CourseAssignment[]> {
		return this.myBaseService.post(searchObj, this.url + "/Active?export=false");
	}
	loadAllExport(searchObj: ePM.Logic.PersonSearchVM): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(searchObj, this.url + "/Active?export=true");
	}
    loadAllForPerson(id: System.Guid): Observable<ePM.Logic.CourseAssignment[]> {
        return this.myBaseService.loadAll(this.url + '/Person/' + (id || ''));
    }
    loadAllForCourse(id: System.Guid): Observable<ePM.Logic.CourseAssignment[]> {
        return this.myBaseService.loadAll(this.url + '/CompanyCourse/' + id);
    }
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.CourseAssignment> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.CourseAssignment> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.CourseAssignment>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<ePM.Logic.CourseAssignment[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search');
	}
	adminFinish(tempItem: ePM.Logic.CourseAssignment): Observable<ePM.Logic.CourseAssignment> {
		return this.myBaseService.save(null, this.url + "/AdminFinish/" + tempItem.CourseAssignmentID);
	}
	startMyself(courseID: System.Guid): Observable<ePM.Logic.CourseAssignment> {
		return this.myBaseService.post(null, this.url + "/StartMyself/" + (courseID || ''));
	}
	printCert(tempItem: ePM.Logic.CourseAssignment): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(null, this.url + '/Cert/' + tempItem.CourseAssignmentID);
	}
}
				